export class UserModel {
    access_token: string | undefined;
    refresh_token: string | undefined;
    expires_in: number | undefined;
    token_type: string | undefined;
    user_id: string | undefined;
    roles: string | undefined;
    tenantId: string | undefined;
    email: string | undefined;
    fullname: string | undefined;
    photo: string | undefined;
    main_role: string | undefined;
    permissions: string | undefined;
    apply_status: string | undefined;
    user_ic: string | undefined;
}